import { isBrowser } from './env'

export async function sha256(message: string) {
  if (isBrowser()) {
    const msgBuffer = new TextEncoder().encode(message)
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('')
    return hashHex
  } else {
    // eslint-disable-next-line unicorn/prefer-node-protocol
    const nodeCrypto = await import('crypto')
    return nodeCrypto.createHash('sha256').update(message).digest('hex')
  }
}
